import React, { ComponentProps, useCallback } from 'react';
import { Controller, FieldValues } from 'react-hook-form';

import { MultiSelect } from '@sbv-clients/ui-shared';

import { useFormFieldError } from '../../hooks/use-field-error';

type FormSelectFieldProps<T> = ComponentProps<typeof MultiSelect> & {
  name?: string;
  withAllOption?: boolean;
};

export const FormMultiSelectField = <T,>({
  name = '',
  options = [],
  onChange,
  onBlur,
  onOpen,
  ...rest
}: FormSelectFieldProps<T>) => {
  const { error, helperText } = useFormFieldError(name);
  const render = useCallback(
    ({ field }: { field: FieldValues }) => (
      <MultiSelect
        {...rest}
        name={name}
        variant="outlined"
        onOpen={onOpen}
        value={field.value ?? null}
        onChange={(event, child) => {
          field.onChange(event);
          onChange?.(event, child);
        }}
        onBlur={(event) => {
          field.onBlur();
          onBlur?.(event);
        }}
        error={error}
        options={options}
        helperText={helperText}
      />
    ),
    [rest, name, onOpen, error, options, helperText, onChange, onBlur]
  );

  return <Controller name={name} render={render} />;
};
